import React from 'react';

/**
 * Renders HTML produced by react-quill.
 * Falls back gracefully for plain-text strings stored before the rich editor was added.
 */
const EditorJsRenderer = ({ value, className }) => {
  if (!value) return null;

  // If it looks like HTML (contains a tag), render it as HTML.
  // Otherwise (plain text legacy content) wrap in a <p>.
  const isHtml = /<[a-z][\s\S]*>/i.test(value);

  if (isHtml) {
    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: value }}
      />
    );
  }

  return <p className={className}>{value}</p>;
};

export default EditorJsRenderer;
